import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { finalize } from 'rxjs/operators';
import { BlogService } from './blog.service';
import { Title } from '@angular/platform-browser';

@Component({
  standalone: false,
    selector: 'app-blog',
    templateUrl: './blog.page.html',
    styleUrls: ['./blog.page.scss'],
})
export class BlogPage implements OnInit {
    posts = [];
    isLoading: boolean;

    constructor(
        private title: Title,
        private blogService: BlogService
    ) { }

    ngOnInit() {
        this.title.setTitle('iOnCourt | Blog');
        this.getBlogPosts();
    }

    getBlogPosts() {
        this.isLoading = true;
        this.blogService.index()
            .pipe(finalize(() => this.isLoading = false))
            .subscribe(
                res => {
                    this.posts = res.data;
                },
                err => {
                    //console.log(err)
                }
            );
    }

    getTitle(title: string) {
        return title.replace('&#8211;', '-');
    }

    async openLink(link) {
        await Browser.open({
            url: link
        });
    }

    async openSocial(social) {
        let link: string;
        if (social === 'facebook') link = 'https://www.facebook.com/ioncourtapp';
        else if (social === 'instagram') link = 'https://www.instagram.com/ioncourtapp';
        else if (social === 'twitter') link = 'https://www.twitter.com/ioncourtapp';
        await Browser.open({
            url: link
        });
    }
}
